// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/sass/style.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { api } from "./api"; // expõe baseURL p/ o SocketProvider (fallback)
import SocketProvider from "./ws/SocketProvider";
import { NotifyProvider } from "./context/notifyStore";
import MsgNotifyListener from "./components/MsgNotifyListener";

// Exponha a baseURL globalmente para o SocketProvider (fallback quando não houver VITE_WS_URL)
try {
  window.__AXIOS__ = { baseURL: api?.defaults?.baseURL || null };
} catch {
  // no-op
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // Atenção: em dev o StrictMode monta/desmonta componentes 2x, então você pode ver 2 conexões no console.
  <React.StrictMode>
    <NotifyProvider>
      <SocketProvider>
        {/* Listener global de notificações de mensagens (badge + avisos) */}
        <MsgNotifyListener />
        <App />
      </SocketProvider>
    </NotifyProvider>
  </React.StrictMode>
);

reportWebVitals();
